import { getMonth, getYear, isAfter, isEqual } from 'date-fns';
import { DISPLAY_DATE } from './constants';
import IDate from './types/date';

/**
 * Standard date format string used across the application
 */
export const dateFormat = DISPLAY_DATE;

/**
 * Checks if a start date is after or equal to a target date
 */
export function isStartDateAfterTargetDate(startDate: Date, targetDate: Date): boolean {
	return isAfter(startDate, targetDate) || isEqual(startDate, targetDate);
}

/**
 * Checks if a selected date is not in a future month
 */
export const isNotInFutureMonth = (selectedDate: Date) => {
	const today = new Date();
	const currentYear = getYear(today);
	const currentMonth = getMonth(today);
	const selectedYear = getYear(selectedDate);
	const selectedMonth = getMonth(selectedDate);

	return !(selectedYear === currentYear && selectedMonth > currentMonth);
};

/**
 * Generates a JavaScript `Date` object from an `IDate` object containing string representations of year, month, and day.
 *
 * @param date - An object containing `year`, `month`, and `day` as strings.
 * @returns A `Date` object representing the specified date.
 */
export const generateDate = (date: IDate) => {
	return new Date(parseInt(date.year, 10), parseInt(date.month, 10) - 1, parseInt(date.day, 10));
};
